import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { breadcrumbsFor, breadcrumbs } from '../../portal/shared/constants/breadcrumbs.constants';

import { Breadcrumb } from '../../portal/shared/models/breadcrumbs.model';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbsService {
  private breadcrumbsSource: BehaviorSubject<Breadcrumb>;
  currentBreadcrumb: Observable<Breadcrumb>;

  setCurrentBreadcrumb(breadcrumb: Breadcrumb) {
    this.breadcrumbsSource.next(breadcrumb);
  }

  getBreadcrumb = (current: string): Breadcrumb => this.extractBreadcrumb(breadcrumbs[current]);

  private extractBreadcrumb = ({ breadcrumb }): Breadcrumb => breadcrumb;

  constructor() {
    this.breadcrumbsSource = new BehaviorSubject(this.getBreadcrumb(breadcrumbsFor.HOME));
    this.currentBreadcrumb = this.breadcrumbsSource.asObservable();
  }
}
